import { AspectRatio, Flex, Heading, Image } from "@chakra-ui/react";
import { type UnifiedNFTBalance, getIPFSurl, isTezosNft, thumbnailUri } from "@umami/chains";

import { useCorsImageUrl } from "../../../hooks/useCorsImageUrl";
import { useColor } from "../../../styles/useColor";

const getNFTData = (nft: UnifiedNFTBalance) => {
  if (isTezosNft(nft)) {
    const url = getIPFSurl(thumbnailUri(nft));
    const fallbackUrl = getIPFSurl(nft.displayUri);
    const name = nft.metadata.name;

    return { url, fallbackUrl, name };
  }

  return {
    url: nft.animationUrl || nft.imageUrl,
    name: nft.name,
    fallbackUrl: nft.metadata.image,
  };
};

export const NFTTile = ({ nft }: { nft: UnifiedNFTBalance }) => {
  const { url, fallbackUrl, name } = getNFTData(nft);
  const color = useColor();
  const corsImageUrl = useCorsImageUrl(url);
  const corsFallbackImageUrl = useCorsImageUrl(fallbackUrl);

  return (
    <Flex
      alignItems="center"
      width="100%"
      padding="15px 16px"
      background={color("100")}
      borderRadius="4px"
      aria-label="nft"
      data-testid="nft-name"
    >
      <AspectRatio width="42px" ratio={1}>
        <Image borderRadius="4px" fallbackSrc={corsFallbackImageUrl} src={corsImageUrl} />
      </AspectRatio>
      <Heading marginLeft="16px" color={color("900")} size="md">
        {name}
      </Heading>
    </Flex>
  );
};
